import React from "react";
import { Provider } from "react-redux";
import * as Sentry from '@sentry/browser';

import store from "./store";
import Container from "./Container";

Sentry.init({dsn: "https://13a35c27d9444027a20ee38e95e6527c@sentry.io/1728486"});

const Main = () => (
  <Provider store={store}>
    <Container />
  </Provider>
);

export default Main;
